document.addEventListener('DOMContentLoaded', function() {
  const triggerButton = document.getElementById('appraisal-trigger-button');
  const modalContent = document.getElementById('appraisal-modal-content');
  const modalOverlay = document.getElementById('appraisal-modal-overlay');
  const closeButton = document.getElementById('appraisal-modal-close');

  function openModal() {
    modalOverlay.style.display = 'block';
    modalContent.style.display = 'block';
  }

  function closeModal() {
    modalOverlay.style.display = 'none';
    modalContent.style.display = 'none';
  }

  if (triggerButton) {
    triggerButton.addEventListener('click', openModal);
  }
  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }
  if (modalOverlay) {
    modalOverlay.addEventListener('click', closeModal);
  }
});